import { useQuery } from '@tanstack/react-query';
import { useConnection } from 'wagmi';

import { Interval } from '@/app/shared/constants/interval';
import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { formatApy, formatUsd } from '@/app/shared/lib/formatters';
import { getUserPortfolio } from '@/app/shared/services/api';

export const useUserPortfolio = (vault?: string) => {
  const { address } = useConnection();

  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.USER_PORTFOLIO, address, vault],
    queryFn: () => getUserPortfolio({ address, vault }),
    enabled: !!address,
    staleTime: Interval.ONE_MIN,
    refetchInterval: Interval.ONE_MIN,
  });

  return {
    data,
    isLoading,
    error,
    isConnected: !!address,
    depositedUsd: formatUsd(data?.depositedUsd),
    currentValueUsd: formatUsd(data?.currentValueUsd),
    yieldEarnedUsd: formatUsd(data?.yieldEarnedUsd),
    apy: formatApy(data?.apy),
    positionsCount: data?.positionsCount ?? 0,
  };
};
